module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid27_1060x868.43f012b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid27_1060x868.jpg
// module id = Mixn
// module chunks = 0